import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=09c6cb5d&scoped=true&"
import script from "./Step.ts?vue&type=script&lang=ts&"
export * from "./Step.ts?vue&type=script&lang=ts&"
import style0 from "./Step.scss?vue&type=style&index=0&id=09c6cb5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c6cb5d",
  null
  
)

export default component.exports